module.exports = __webpack_public_path__ + "media/site/images/case_studies/sensor_cloud/header-099fdca695c99ab8bcee6a9fdd812698.png";